.reusable-button {
  margin-left: 10px;
}

.active-manual-store-tooltip {
  display: inline-block;
  font-size: 12px;
  line-height: 18px;
  padding: 0 2px;
}
